/** Synchronous guard: React state alone does not block two actions in one tick. */
export default class CandidateSearchRequestGate {
    private controller?: AbortController;

    private generation = 0;

    get version(): number { return this.generation; }

    get pending(): boolean { return !!this.controller; }

    begin(): { version: number; signal: AbortSignal } | undefined {
        if (this.controller) return undefined;
        this.generation += 1;
        this.controller = new AbortController();
        return { version: this.generation, signal: this.controller.signal };
    }

    isCurrent(version: number): boolean { return version === this.generation; }

    finish(version: number): boolean {
        if (!this.isCurrent(version)) return false;
        this.controller = undefined;
        return true;
    }

    invalidate(): void {
        this.generation += 1;
        this.controller?.abort();
        this.controller = undefined;
    }
}
